import RBush from "rbush";
export function serializeInputs(inputs) {
    const containerMap = {};
    for (const key of inputs.containerMap.keys()) {
        const container = inputs.containerMap.get(key);
        if (!container) {
            continue;
        }
        // We need to serialize the RBush data structure for portability to the worker
        containerMap[key] = {
            ...container,
            quadTree: container.quadTree.toJSON(),
        };
    }
    const nodeShapes = Array.from(inputs.nodeShapesMap.values());
    return {
        nodeShapes, // Note: contains THREEJS Matrices that become element arrays
        pcbLayoutNodes: inputs.pcbLayoutNodes,
        containerMap,
    };
}
export async function deserializeInputs(inputs) {
    const containerMap = new Map();
    for (const key in inputs.containerMap) {
        const json = inputs.containerMap[key];
        if (!json) {
            throw new Error(`Invalid container ${key}`);
        }
        const primitiveContainer = {
            transform: json.transform,
            transformInverse: json.transformInverse,
            quadTree: new RBush().fromJSON(json.quadTree),
        };
        containerMap.set(key, primitiveContainer);
    }
    return {
        nodeShapes: inputs.nodeShapes,
        pcbLayoutNodes: inputs.pcbLayoutNodes,
        containerMap,
    };
}
//# sourceMappingURL=serde.js.map